module.exports = __webpack_public_path__ + "img/f3bdb7b.jpg";